module.exports = __webpack_public_path__ + "static/media/plus_circle_blue.42e25fb5.svg";